import { makeStyles } from '@mui/styles';

const LOGIN_BACKGROUND_IMAGE = 'https://suite.coordinadora.com/images/Hub-Autenticacion-mini-N.png';

const useLoginPageStyles = makeStyles({
	root: {
		minHeight: '100vh',
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: '#0b1f33',
		backgroundImage: `linear-gradient(rgba(11, 31, 51, 0.35), rgba(11, 31, 51, 0.35)), url(${LOGIN_BACKGROUND_IMAGE})`,
		backgroundSize: 'cover',
		backgroundPosition: 'center',
		backgroundRepeat: 'no-repeat',
		padding: 24,
		boxSizing: 'border-box',
	},
	card: {
		width: '100%',
		maxWidth: 420,
		backgroundColor: '#ffffff',
		borderRadius: 8,
		padding: '40px 32px',
		boxShadow: '0 12px 40px rgba(0, 0, 0, 0.25)',
		textAlign: 'center',
	},
	logo: {
		height: 28,
		width: 'auto',
		marginBottom: 24,
	},
	title: {
		margin: 0,
		fontSize: 24,
		fontWeight: 700,
		color: '#0b1f33',
	},
	subtitle: {
		margin: '12px 0 28px',
		fontSize: 14,
		lineHeight: 1.5,
		color: '#4a5568',
	},
	button: {
		width: '100%',
		border: 'none',
		borderRadius: 6,
		padding: '12px 16px',
		fontSize: 15,
		fontWeight: 600,
		cursor: 'pointer',
		backgroundColor: '#1a73e8',
		color: '#ffffff',
		'&:hover': {
			backgroundColor: '#1558b0',
		},
	},
	corporateHint: {
		marginTop: 20,
		fontSize: 12,
		color: '#718096',
	},
});

export default useLoginPageStyles;
